module.exports = __webpack_public_path__ + "static/media/Explore Top Eateries.bd1a87bb.webp";